import { useParams } from "react-router-dom";
import { RcList } from "@/screens/Rcs/rc-list";

// App-scoped RC configs tab — same list, app locked.
const AppRcs = () => {
  const { id } = useParams();
  return <RcList pid={String(id)} />;
};

export default AppRcs;
